import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";

const DispatchReasonContent = ({ data }) => {
    const dispatch = data?.dispatch_nature ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = dispatch.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    useEffect(() => {
        if (!dispatch?.length) return;
        const values = [];

        dispatch.map((element) => {
            values.push([
                element.dispatch_nature,
                element.qty
            ]);
        })

        ReportUtils.createExportableTable(["Natureza", "Quantidade"], values, 'Despachos por natureza');
    }, [data]);

    return (
        <>
            <div className="mt-4">
                <div className="chart"><span className="chart-title mb-2">Despachos por natureza {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span></div>
                <table id="dispatch-by-reason-data" className="table report-table mt-2" sheet-name="Despachos por natureza">
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[85%]">Natureza</th>
                            <th className="w-[15%]">Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !dispatch?.length ? (
                            <NoDataRow colSpan={2} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? dispatch.slice(0, limit) : dispatch).map((element, index) => (
                            <tr key={index}>
                                <td className="w-[85%]">{element.dispatch_nature}</td>
                                <td className="w-[15%]">{element.qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>

            <div className="chart-divisor print:hidden"/>
        </>
    );
};

export default DispatchReasonContent;